import React, { forwardRef } from 'react';
import { ChevronRight } from 'assets/icons';

const body = {
  info: 'bg-[#EFF6FF]',
  warning: 'bg-[#FFF6EB]',
  alert: 'bg-[#FEF2F2]',
};

const titleColor = {
  info: 'text-blue-900',
  warning: 'text-[#6B3D0A]',
  alert: 'text-red-900',
};

const contentColor = {
  info: 'text-blue-700',
  warning: 'text-[#975612]',
  alert: 'text-red-700',
};

const actionColor = {
  info: 'text-blue-700',
  warning: 'text-[#D77A1E]',
  alert: 'text-red-700',
};

const chevronColor = {
  info: '#1D4ED8',
  warning: '#D77A1E',
  alert: '#B91C1C',
};

const BannerTitle = forwardRef(({ type = 'warning', title, children, action }, ref) => (
  <div
    ref={ref}
    className={`w-full rounded-lg ${body[type]}`}
    style={{ padding: '10px 16px' }}
    role="alert"
  >
    <div className="flex flex-col" style={{ gap: '6px' }}>
      {title && (
        <div
          className={`font-medium ${titleColor[type]}`}
          style={{ fontSize: '16px', lineHeight: '24px' }}
        >
          {title}
        </div>
      )}
      {children && (
        <div
          className={`font-normal ${contentColor[type]}`}
          style={{ fontSize: '14px', lineHeight: '20px' }}
        >
          {children}
        </div>
      )}
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          className={`flex items-center gap-1 font-medium ${actionColor[type]} hover:underline`}
          style={{ fontSize: '14px', lineHeight: '20px' }}
        >
          <span>{action.label}</span>
          <ChevronRight wh={16} color={chevronColor[type]} />
        </button>
      )}
    </div>
  </div>
));

export default BannerTitle;
